export enum CmsComponentTypeEnum {
  ACCORDION = 'ACCORDION',
  AUDIO = 'AUDIO',
  CARD = 'CARD',
  CARDS = 'CARDS',
  CARDS_SLIDER = 'CARDS_SLIDER',
  CTA = 'CTA',
  DIVIDER = 'DIVIDER',
  FORM = 'FORM',
  FREE_TEXT = 'FREE_TEXT',
  WEBINAR_DIALOG = "WEBINAR_DIALOG",
  IMAGE_LEFT = 'IMAGE_LEFT',
  HERO_SLIDER = 'HERO_SLIDER',
  LOGO_SLIDER = 'LOGO_SLIDER',
  NEWS_TICKER_ITEM = 'NEWS_TICKER_ITEM',
  NAVIGATION_WIDGET = "NAVIGATION_WIDGET",
  MEDIA = 'MEDIA',
  MEMBER = 'MEMBER',
  MULTIPLE_COLUMN = 'MULTIPLE_COLUMN',
  SMALL_COLUMN_MODULE = "SMALL_COLUMN_MODULE",
  RELATED_ITEMS = 'RELATED_ITEMS',
  RELATED_SOLUTIONS = 'RELATED_SOLUTIONS',
  SECTION_HEADLINE = 'SECTION_HEADLINE',
  SOCIAL_LINKS = 'SOCIAL_LINKS',
  MEDIA_SLIDER = 'MEDIA_SLIDER',
  NEWS_CARD = 'NEWS_CARD',
  TEAM = 'TEAM',
  TESTIMONIAL_SLIDER = 'TESTIMONIAL_SLIDER',
  TEXT_MARGINAL = 'TEXT_MARGINAL',
  TEXT_MEDIA_BOX = 'TEXT_MEDIA_BOX',
  WIDGET = 'WIDGET',
}
